import React from 'react';
import { Box, Typography } from '@mui/material';
import { portalMetricTileSx } from '../../../styles/portalSurfaces';
import { formatPercentDisplay, normalizeMetric } from '../utils/metricFormatters';

const formatTimeToFirstIntro = (metric) => {
  if (metric?.displayValue != null && String(metric.displayValue).trim() !== '') {
    return String(metric.displayValue);
  }
  if (metric?.averageHours != null && !Number.isNaN(Number(metric.averageHours))) {
    return `${metric.averageHours}h`;
  }
  return '—';
};

const onboardingStages = [
  {
    label: 'Profile Completion',
    key: 'completedProfile',
    valueColor: '#23B80C',
  },
  {
    label: 'Time to First Intro',
    key: 'timeToFirstIntro',
    valueColor: '#D85B45',
  },
];

const Onboarding = ({ metrics }) => {
  const apiJourney = metrics?.connectionJourney || {};

  const onboardingData = onboardingStages.map((stage) => {
    if (stage.key === 'completedProfile') {
      const completed = normalizeMetric(apiJourney.completedProfile);
      return {
        ...stage,
        value: completed ? formatPercentDisplay(completed.percentage) : '0%',
      };
    }

    if (stage.key === 'timeToFirstIntro') {
      return {
        ...stage,
        value: formatTimeToFirstIntro(apiJourney.timeToFirstIntro),
      };
    }

    return stage;
  });

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          Onboarding
        </Typography>
      </Box>

      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {onboardingData.map((item) => (
          <Box key={item.label} sx={portalMetricTileSx}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                lineHeight: 1.25,
                mb: 1,
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 600,
                lineHeight: 1.15,
                color: item.valueColor,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Onboarding;
